export const BUSINESS_QUERY_KEY = 'business'
export const BUSINESS_ANONYMOUSLY_QUERY_KEY = 'businessAnonymously'
export const BUSINESS_COUNT_BY_OWNER_EMAIL_QUERY_KEY = 'businessCountByOwnerEmail'
